
export default function FlowChart() {
  const flowSteps = [
    { icon: 'ri-edit-line', label: '情報入力', time: '5分', color: 'from-teal-500 to-teal-600' },
    { icon: 'ri-camera-line', label: '本人確認', time: '3分', color: 'from-emerald-500 to-emerald-600' },
    { icon: 'ri-search-eye-line', label: '審査', time: '即日〜', color: 'from-green-500 to-green-600' },
    { icon: 'ri-bank-line', label: '入金', time: '2分', color: 'from-teal-600 to-emerald-700' },
    { icon: 'ri-line-chart-line', label: '取引開始', time: '', color: 'from-emerald-600 to-green-700' },
  ];

  return (
    <section className="py-14 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">口座開設フローチャート</h2>
          <p className="text-sm text-gray-600">全体の流れを一目で確認</p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-0">
          {flowSteps.map((step, i) => (
            <div key={i} className="flex items-center">
              <div className="flex flex-col items-center">
                <div className={`w-16 h-16 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                <p className="text-sm font-bold text-gray-900 mt-2">{step.label}</p>
                {step.time && <p className="text-xs text-teal-600 font-medium">{step.time}</p>}
              </div>
              {i < flowSteps.length - 1 && (
                <div className="hidden md:flex items-center mx-4">
                  <div className="w-8 h-px bg-gradient-to-r from-teal-300 to-emerald-300"></div>
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                </div>
              )}
              {i < flowSteps.length - 1 && (
                <div className="md:hidden flex flex-col items-center my-1">
                  <i className="ri-arrow-down-s-line text-teal-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
